import isUrl from 'is-url';
import { ReactEditor } from 'slate-react';

import { withInline } from 'craft/rte/plugins/withInline';

import { wrapLink } from './wrapLink';

export const withLink = ({ typeLink }: { typeLink: string }) => <T extends ReactEditor>(
  editor: T,
) => {
  // eslint-disable-next-line no-param-reassign
  editor = withInline([typeLink])(editor);

  const { insertData, insertText } = editor;

  // eslint-disable-next-line no-param-reassign
  editor.insertText = (text) => {
    if (text && isUrl(text)) {
      wrapLink(editor, { href: text }, { typeLink });
    } else {
      insertText(text);
    }
  };

  // eslint-disable-next-line no-param-reassign
  editor.insertData = (data: DataTransfer) => {
    const text = data.getData('text/plain');

    if (text && isUrl(text)) {
      wrapLink(editor, { href: text }, { typeLink });
    } else {
      insertData(data);
    }
  };

  return editor;
};
